export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14800.dd5aa07e.jpg";